export enum SearchType {
	CoursesSearch = 0,
	InfluensersSearch = 1,
	ThreadsSearch = 2,
	GroupsSearch = 3,
}
